var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnAddImgInCircle = function SvgIcnBtnAddImgInCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1A1A1A",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.75H13C7.57 26.75 5.25 24.43 5.25 19V13C5.25 7.57 7.57 5.25 13 5.25H19C24.43 5.25 26.75 7.57 26.75 13V19C26.75 24.43 24.43 26.75 19 26.75ZM13 6.75C8.39 6.75 6.75 8.39 6.75 13V19C6.75 23.61 8.39 25.25 13 25.25H19C23.61 25.25 25.25 23.61 25.25 19V13C25.25 8.39 23.61 6.75 19 6.75H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.75C11.48 14.75 10.25 13.52 10.25 12C10.25 10.48 11.48 9.25 13 9.25C14.52 9.25 15.75 10.48 15.75 12C15.75 13.52 14.52 14.75 13 14.75ZM13 10.75C12.31 10.75 11.75 11.31 11.75 12C11.75 12.69 12.31 13.25 13 13.25C13.69 13.25 14.25 12.69 14.25 12C14.25 11.31 13.69 10.75 13 10.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67075 23.7001C6.43075 23.7001 6.19075 23.5801 6.05075 23.3701C5.82075 23.0301 5.91075 22.5601 6.26075 22.3301L11.1907 19.0201C12.2707 18.2901 13.7607 18.3801 14.7407 19.2101L15.0707 19.5001C15.5707 19.9301 16.4207 19.9301 16.9107 19.5001L21.0708 15.9301C22.1308 15.0201 23.8008 15.0201 24.8708 15.9301L26.5008 17.3301C26.8108 17.6001 26.8508 18.0701 26.5808 18.3901C26.3108 18.7001 25.8408 18.7401 25.5208 18.4701L23.8907 17.0701C23.3907 16.6401 22.5408 16.6401 22.0408 17.0701L17.8808 20.6401C16.8208 21.5501 15.1507 21.5501 14.0807 20.6401L13.7507 20.3501C13.2907 19.9601 12.5307 19.9201 12.0207 20.2701L7.09075 23.5801C6.96075 23.6601 6.81075 23.7001 6.67075 23.7001Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnAddImgInCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_add_img_in_circle.23500d7c.svg";
export { ForwardRef as ReactComponent };